import { AdminDTO, ApiQuery, ApiResponse, PasswordDTO, PartnerUserDTO } from "@/@types";
import { UserEntity } from "@/domain/entities";
import { User } from "@/domain/models";
import { Endpoints, Http, HttpService } from "@/infra/api";

export interface UserRepository {
  getUser: (id: string) => Promise<ApiResponse<User>>;
  getUsers: (query?: ApiQuery) => Promise<ApiResponse<User[]>>;
  createAdmin: (params: AdminDTO) => Promise<ApiResponse<User>>;
  createPartnerUser: (params: PartnerUserDTO) => Promise<ApiResponse<User>>;
  updateAdmin: (
    id: string,
    params: Pick<AdminDTO, "name">
  ) => Promise<ApiResponse<User>>;
  updatePassword: (
    id: string,
    params: PasswordDTO
  ) => Promise<ApiResponse<User>>;
  deleteAdmin: (id: string) => Promise<ApiResponse<UserEntity>>;
}

export const UserService = (http: Http = HttpService()): UserRepository => ({
  getUser: async (id) => {
    const res = await http.get<UserEntity>(`${Endpoints.users}/${id}`);
    const data = new User(res.data);
    return { ...res, data };
  },
  getUsers: async (query?: ApiQuery) => {
    const res = await http.get<UserEntity[]>(Endpoints.users, query);
    const data = res.data?.length ? res.data.map((user) => new User(user)) : [];
    return { ...res, data };
  },
  createAdmin: async (params) => {
    const res = await http.post<AdminDTO, UserEntity>(Endpoints.users, params);
    const data = new User(res.data);
    return { ...res, data };
  },
  createPartnerUser: async (params) => {
    const res = await http.post<PartnerUserDTO, UserEntity>(Endpoints.users, params);
    const data = new User(res.data);
    return { ...res, data };
  },
  updateAdmin: async (id, params) => {
    const res = await http.post<Pick<AdminDTO, "name">, UserEntity>(
      `${Endpoints.users}/${id}/update`,
      params
    );
    const data = new User(res.data);
    return { ...res, data };
  },
  updatePassword: async (id, params) => {
    const res = await http.post<PasswordDTO, UserEntity>(
      `${Endpoints.users}/${id}/update`,
      params
    );
    const data = new User(res.data);
    return { ...res, data };
  },
  deleteAdmin: (id) => {
    return http.delete<UserEntity>(`${Endpoints.users}/${id}`);
  },
});
